module.exports = __webpack_public_path__ + "html/user-table.template.html";